import type { ContestSettings } from '@betterpool/api-types/contests-service';

import type { PlayerDetail } from '~/domains/games/interfaces/player-detail.interface';

import type { PlayerGroupedStats } from '../../components/GamecenterPlayerDetail/GamecenterPlayerDetailStats';
import formatEarnings from '../../utils/formatEarnings';
import { roundGolfStat, toFixedGolfStat } from '../golfStatFormatters';

const parseGolf = (
  playerData: PlayerDetail,
  scoreType?: ContestSettings['scoreType']
): PlayerGroupedStats => ({
  name: 'Season Tournament Stats',
  orderedStats: [
    scoreType === 'dollars' && {
      name: 'EARNINGS',
      value: formatEarnings(playerData.attributes?.earnings),
    },
    {
      name: 'WINS',
      value: roundGolfStat(playerData.attributes?.first_place),
    },
    {
      name: 'Top 10s',
      value: roundGolfStat(playerData.attributes?.top_10),
    },
    {
      name: 'Top 25s',
      value: roundGolfStat(playerData.attributes?.top_25),
    },
    {
      name: 'AVG SCORE',
      value: toFixedGolfStat(playerData.attributes?.scoring_avg),
    },
    {
      name: 'Missed Cuts',
      value: roundGolfStat(playerData.attributes?.cuts),
    },
    {
      name: 'BIRDIES PER RD',
      value: toFixedGolfStat(playerData.attributes?.birdies_per_round),
    },
  ].filter(Boolean),
});

export default parseGolf;
